import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const container = "omponents__Slider__ThresholdSlider__styles_ts-container-c1ysbw49";
export const sxStyles = (value: string[], trailColor: string, primaryColor: string, secondaryColor: string, max: number) => {
  const lower = value[0];
  const upper = value[1];
  const formattedLower = +lower / max * 100;
  const formattedUpper = +upper / max * 100;
  return {
    margin: '0 1rem',
    '& .MuiSlider-rail': {
      opacity: 1,
      // eslint-disable-next-line max-len
      background: `linear-gradient(to right, ${trailColor} 0% ${formattedLower}%, ${primaryColor} ${formattedLower}% ${formattedUpper}%, ${secondaryColor} ${formattedUpper}% 100%)`
    },
    '& .MuiSlider-track': {
      background: primaryColor
    },
    '& .MuiSlider-thumb': {
      width: '1.5rem',
      height: '1.5rem'
    }
  };
};
export const input = "omponents__Slider__ThresholdSlider__styles_ts-input-i13db5z8";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");